import showFlash from "flash-message";

(function() {
    import("angular").then(angular => {
        var app = angular.module("tapAssetManager");

        app.controller("sharerTwitterCtrl", [
            "$scope",
            "sharerTwitter",
            function($scope, sharerTwitter) {
                "use strict";

                $scope.twitter = $scope.twitter || {};

                $scope.twitter.getCharacterCount = function() {
                    var count = sharerTwitter.shortUrlLength + 1 + $scope.textContent.length;
                    count += $scope.asset.type === "image_banner" ? 24 : 0;

                    return count;
                };

                $scope.twitter.isWithinMaxCharacters = function() {
                    var maxCharacters = 280 - 1 - sharerTwitter.shortUrlLength;
                    maxCharacters -= $scope.asset.type === "image_banner" ? 24 : 0;

                    return $scope.textContent.length <= maxCharacters;
                };

                $scope.twitter.submit = function(status) {
                    $scope.posting = true;
                    status = status.trim() + " " + $scope.currentLink;

                    return sharerTwitter.post($scope.asset, $scope.selectedData.selectedSource, status, function(err) {
                        $scope.posting = false;

                        import("utils/translator").then(Translator => {
                            if (err) {
                                showFlash("warning", Translator.trans("unknown_error_warning"));
                            } else {
                                showFlash("success", Translator.trans("social.tweet_sent", {}, "TapSiteBundle_Pi"));
                            }
                        });

                        $scope.shareModal.close();
                    });
                };

                $scope.twitter.close = function() {
                    $scope.shareModal.close();
                };
            },
        ]);
    });
})();
